import {
    LOAD_REPORT_DATA,
    LOAD_REPORT_DATA_SUCCESS,
    LOAD_REPORT_DATA_FAILURE,
    CLEAR_REPORT_DATA,
    LOAD_MONTHLY_DATA,
    LOAD_MONTHLY_DATA_SUCCESS,
    LOAD_MONTHLY_DATA_FAILURE,
} from "../actions/types";

const DEFAULT_USER_SETTINGS = {
    report: {
        data: [],
        loading: false,
        error: null
    },
    monthlyData: {
        data: [],
        loading: false,
        error: null
    },
};

//eslint-disable-next-line
export default (state = DEFAULT_USER_SETTINGS, action) => {
    switch (action.type) {
        case LOAD_REPORT_DATA:
            return { ...state, report: { ...state.report, data: [], loading: true, } };
        case LOAD_REPORT_DATA_SUCCESS:
            return {
                ...state,
                report: { ...state.report, loading: false, data: action.payload }
            };
        case LOAD_REPORT_DATA_FAILURE:
            return { ...state, report: { ...state.report, loading: false, data: [] } }
        case CLEAR_REPORT_DATA:
            return { ...state, report: { loading: false, data: [], error: null } }
        case LOAD_MONTHLY_DATA:
            return { ...state, monthlyData: { ...state.monthlyData, data: [], loading: true, } };
        case LOAD_MONTHLY_DATA_SUCCESS:
            return {
                ...state,
                monthlyData: { ...state.monthlyData, loading: false, data: action.payload }
            }
        case LOAD_MONTHLY_DATA_FAILURE:
            return {
                ...state,
                monthlyData: { ...state.monthlyData, loading: false, data: [] }
            }
        default:
            return state;
    }
};

